import React, {Component} from 'react';
import {Col, ControlLabel, Form, FormGroup} from "react-bootstrap";
import {TopSelect} from "../../../../componentsTopsa/selects/TopSelects";
import {TopButtonAction} from "../../../../componentsTopsa/buttons/TopButtons";
import CennikBiletowService from "../../../konfiguracja/biletyConfig/cenyBiletow/CennikBiletowService";
import LogowanieService from "../../../logowanie/LogowanieService";

export default class UrzadRaportCennikowSearchbox extends Component {
    constructor(props) {
        super(props);

        console.log('test')
        console.log(LogowanieService.sprawdzCzyToAdmin())

        this.state = {
            typ: null,
            typy: [
                {value: 'BASE', label: 'jednorazowe'},
                {value: 'BASEM', label: 'miesięczne', disabled: !LogowanieService.sprawdzCzyToAdmin()},
            ],
            linia: null,
            data: null,
            daty: []
        };

    }

    componentDidMount() {
    }

    onClickSzukaj() {
        if (!Boolean(this.state.linia) || !Boolean(this.state.data)) {
            alert('Należy uzupełnić obydwa pola select!')
        } else
            this.props.handleClickSzukaj(this.state.linia, this.state.data.value, this.state.typ.value)

    }

    renderLinia(option) {
        return (<div><span className={'label label-ebus-primary'}> nr. {option.numer}</span> {option.relacja}</div>)
    }

    onChangeLinia(e) {
        this.setState({linia: e})
        if (e !== null) {
            this.szukajDatCennikaBazowego(e.trasaGlownaId, this.state.typ.value)
        }
    }

    onChangeData(e) {
        this.setState({data: e})
    }

    onChangeTyp(e) {
        this.setState({typ: e})
        if (this.state.linia !== null) {
            this.szukajDatCennikaBazowego(this.state.linia.trasaGlownaId, e.value)
        }
    }

    szukajDatCennikaBazowego(idTr, typ) {
        CennikBiletowService.pobierzDatyCennikow(idTr, typ).then(function (response) {
            if (response.status < 300)
                this.setState({
                    daty: Array.from(response.data, item => {
                        return {value: item, label: item}
                    }),
                    data: {
                        value: response.data[response.data.length - 1],
                        label: response.data[response.data.length - 1]
                    }
                })
        }.bind(this))
    }

    render() {

        return (
            <div>
                <Form horizontal={true}>
                    <FormGroup style={{marginBottom: '0'}}>
                        <Col xs={6} lg={2}>
                            <ControlLabel>Wybierz typ</ControlLabel>
                            <TopSelect onChange={(e) => {
                                this.onChangeTyp(e)
                            }} value={this.state.typ} options={this.state.typy} clearable={false}
                            />
                        </Col>
                        <Col xs={6} lg={3}>
                            <ControlLabel>Wybierz linię</ControlLabel>
                            <TopSelect onChange={(e) => {
                                this.onChangeLinia(e)
                            }} value={this.state.linia} options={this.props.linie}
                                       valueKey={'idLi'} labelKey={'relacja'} disabled={!Boolean(this.state.typ)}
                                       clearable={false} valueRenderer={this.renderLinia}
                                       optionRenderer={this.renderLinia}
                            />
                        </Col>
                        <Col xs={6} lg={2}>
                            <ControlLabel>Wybierz datę cennika</ControlLabel>
                            <TopSelect onChange={(e) => {
                                this.onChangeData(e)
                            }} value={this.state.data} options={this.state.daty} disabled={!Boolean(this.state.linia)}
                                       clearable={false}/>
                        </Col>
                        <Col xs={6} lg={2}>
                            <div className={'add-label-margin'}></div>
                            <TopButtonAction text={'Pokaż raport'} iconType={'fa fa-file-text-o'}
                                             onClick={() => this.onClickSzukaj()}
                                             btnSize={'medium'}/>
                        </Col>
                    </FormGroup>
                </Form>
            </div>
        );
    }
}




// WEBPACK FOOTER //
// ./src/modules/urzadModule/raport_cennikow/components/UrzadRaportCennikowSearchbox.js